"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlCardGroup = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
function IlCardGroup(props) {
    return (react_1.default.createElement(material_1.Stack, { sx: __assign({ borderWidth: '0.0625rem', borderColor: 'action.disabledBackground', borderStyle: 'solid', borderRadius: '0.125rem', overflow: 'hidden' }, props.sx) }, react_1.default.Children.map(props.children, function (child, index) {
        var _a;
        return react_1.default.cloneElement(child, {
            key: (_a = child.key) !== null && _a !== void 0 ? _a : index,
            sx: __assign({ '& + &::before': __assign({ position: 'relative', width: '100%', top: '-0.75rem', display: 'flex', ml: '1.75rem', height: '0.0165rem', content: '""', backgroundColor: 'action.disabledBackground' }, props.lineSx) }, child.props.sx),
        });
    })));
}
exports.IlCardGroup = IlCardGroup;
